import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { Empresa } from 'src/app/classes/Empresa';
import { Usuario, enumPerfil } from 'src/app/classes/Usuario';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
  perfis?: number[];
  permissoes?: string[];
  docLink?: string;
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

@Injectable()
export class NavigationItem {
  constructor(private storageService: StorageService) {
  }
  public getProvider() {
    var NavigationItems = [
        {
          id: 'other',
          title: this.storageService.getEmpresa() ? this.storageService.getEmpresa().NomeFantasia.toUpperCase() : 'Painel Fornecedor',
          type: 'group',
          icon: 'feather icon-align-left',
          children: [
            {
              id: 'mapa',
              title: 'MAPA',
              type: 'item',
              url: '/mapa',
              classes: 'nav-item',
              icon: 'feather icon-map',
              breadcrumbs: false,
            },
            {
              id: 'painel',
              title: 'PAINEL_GERENCIAL',
              type: 'item',
              url: '/painel',
              classes: 'nav-item',
              icon: 'feather icon-sidebar',
              breadcrumbs: false,
            },
            {
              id: 'chamado',
              title: 'CHAMADOS',
              type: 'item',
              url: '/chamado',
              classes: 'nav-item',
              icon: 'feather icon-list',
              breadcrumbs: false,
              perfis: [enumPerfil.Super]
            },

            {
              id: 'gerenciador',
              title: 'GERENCIADOR',
              type: 'collapse',
              icon: 'feather icon-sliders',
              perfis: [enumPerfil.Super],
              children: [
                {
                  id: 'empresa',
                  title: 'EMPRESAS',
                  type: 'item',
                  url: '/gerenciador/empresa'
                },
                {
                  id: 'cultura',
                  title: 'CULTURAS',
                  type: 'item',
                  url: '/gerenciador/cultura'
                },

                {
                  id: 'variedade',
                  title: 'VARIEDADES',
                  type: 'item',
                  url: '/cadastros/variedade',
                },
                {
                  id: 'tipo-bico',
                  title: 'TIPOS_DE_BICOS',
                  type: 'item',
                  url: '/gerenciador/tipo-bico'
                },
                {
                  id: 'ano-agricola',
                  title: 'ANOS_AGRICOLAS',
                  type: 'item',
                  url: '/gerenciador/ano-agricola'
                },
                {
                  id: 'parceiros',
                  title: 'Parceiros',
                  type: 'item',
                  url: '/cadastros/parceiros'
                },
                {
                  id: 'regionais',
                  title: 'Regionais',
                  type: 'item',
                  url: '/cadastros/regionais'
                },
                {
                  id: 'empresa-interna',
                  title: 'Empresas',
                  type: 'item',
                  url: '/cadastros/empresa-interna',
                  perfis: [enumPerfil.Super, enumPerfil.Admin],
                },
                {
                  id: 'pessoa',
                  title: 'Pessoas',
                  type: 'item',
                  url: '/cadastros/pessoa',
                },
                {
                  id: 'natureza',
                  title: 'Naturezas',
                  type: 'item',
                  url: '/cadastros/natureza',
                },
                {
                  id: 'centro-de-resultados',
                  title: 'Centro de Resultados',
                  type: 'item',
                  url: '/cadastros/centro-de-resultados',
                },
                {
                  id: 'projeto',
                  title: 'Projetos',
                  type: 'item',
                  url: '/cadastros/projeto',
                },
                {
                  id: 'fornecedor',
                  title: 'Fornecedores',
                  type: 'item',
                  url: '/cadastros/fornecedor',
                  breadcrumbs: false,
                  perfis: [enumPerfil.Super],
                }
              ]
            },
            {
              id: 'cadastros',
              title: 'CADASTROS',
              type: 'collapse',
              icon: 'feather icon-edit',
              perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
              breadcrumbs: false,
              children: [
                {
                  id: 'agricolas',
                  title: 'Agrícolas',
                  type: 'collapse',
                  breadcrumbs: true,
                  children: [
                    {
                      id: 'setores',
                      title: 'SETORES',
                      type: 'item',
                      url: '/cadastros/setor',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                      breadcrumbs: false,
                      hidden: !(this.storageService.getEmpresa() && this.storageService.getEmpresa().UsaSetores)
                    },
                    {
                      id: 'fazenda',
                      title: 'FAZENDAS_E_GLEBAS',
                      type: 'item',
                      url: '/cadastros/fazenda',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                      breadcrumbs: false
                    },
                    {
                      id: 'variedades',
                      title: 'VARIEDADES',
                      type: 'item',
                      url: '/cadastros/variedade',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                      breadcrumbs: false

                    },
                    {
                      id: 'processo-planejamento',
                      title: 'PROCESSOS_DE_PLANEJAMENTO',
                      type: 'item',
                      url: '/cadastros/processo-planejamento',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                    },
                    {
                      id: 'grupo-operacao',
                      title: 'OPERACOES_AGRICOLAS',
                      type: 'item',
                      url: '/cadastros/grupo-operacao',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                    },
                    {
                      id: 'tipo-aplicacao',
                      title: 'TIPOS_DE_APLICACOES',
                      type: 'item',
                      url: '/cadastros/tipo-aplicacao',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                      breadcrumbs: false
                    },
                    {
                      id: 'grupo-equipamento',
                      title: 'GRUPOS_DE_EQUIPAMENTO',
                      type: 'item',
                      url: '/cadastros/grupo-equipamento',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                      breadcrumbs: false
                    },
                    {
                      id: 'equipamento',
                      title: 'Equipamentos',
                      type: 'item',
                      url: '/cadastros/equipamento',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                      breadcrumbs: false
                    },
                    {
                      id: 'tipo-improdutividade',
                      title: 'TIPOS_DE_PARADA',
                      type: 'item',
                      url: '/cadastros/tipo-improdutividade',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                    },
                    {
                      id: 'escala-trabalho',
                      title: 'Escalas de Trabalho',
                      type: 'item',
                      url: '/cadastros/escala-trabalho',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                    },
                    {
                      id: 'funcionario',
                      title: 'Funcionários',
                      type: 'item',
                      url: '/cadastros/funcionario',
                      breadcrumbs: false,
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                    },
                  ]
                },
                {
                  id: 'cadastro-estoque',
                  title: 'Suprimentos',
                  type: 'collapse',
                  breadcrumbs: false,
                  children: [
                    {
                      id: 'local-estoque',
                      title: 'Locais de Estoques',
                      type: 'item',
                      url: '/estoques/local-estoque',
                      breadcrumbs: false,
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                    },
                    {
                      id: 'grupo-produto',
                      title: 'GRUPOS_DE_PRODUTOS',
                      type: 'item',
                      url: '/estoques/grupo-produto',
                      breadcrumbs: false,
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                    },

                    {
                      id: 'produto',
                      title: 'PRODUTOS',
                      type: 'item',
                      url: '/estoques/produto',
                      perfis: [enumPerfil.Super, enumPerfil.Admin],
                      breadcrumbs: false,
                    },
                  ]
                },
              ]
            },
            {
              id: 'manutencao',
              title: 'NAV_MANUTENCAO',
              type: 'None',
              icon: 'feather icon-check-square',
              children: [
                {
                  id: 'ordem-servico',
                  title: 'ORDENS_DE_SERVICO',
                  type: 'item',
                  url: '/manutencao/ordem-servico',
                  perfis: [enumPerfil.Super, enumPerfil.Admin],
                }]
            },
            {
              id: 'planejamento',
              title: 'PLANEJAMENTOS',
              type: 'collapse',
              icon: 'feather icon-sliders',
              perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
              children: [
                {
                  id: 'plano-mestre-producao',
                  title: 'PLANO_AGRONOMICO',
                  type: 'item',
                  url: '/planejamento/plano-mestre-producao',
                  perfis: [enumPerfil.Super, enumPerfil.Admin],
                  permissoes: ['VisualizarPlanoAgronomico'],
                  breadcrumbs: false,
                },
                {
                  id: 'safra',
                  title: 'SAFRAS',
                  type: 'item',
                  url: '/planejamento/safra',
                  perfis: [enumPerfil.Super, enumPerfil.Admin],
                  permissoes: ['VisualizarAnoSafra'],
                  breadcrumbs: false
                },
                {
                  id: 'lista-tarefas',
                  title: 'TAREFAS',
                  type: 'item',
                  url: '/planejamento/tarefas',
                  perfis: [enumPerfil.Super, enumPerfil.Admin]
                },
              ]
            },
            {
              id: 'compras',
              title: 'COMPRAS',
              type: 'collapse',
              icon: 'feather icon-shopping-cart',
              perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
              permissoes: ['VisualizarSolicitacaoCompras'],
              hidden: !(this.storageService.getEmpresa() && this.storageService.getEmpresa().AcessoSolicitacaoCompra),
              children: [
                {
                  id: 'solicitacao-compra',
                  title: 'SOLICITACAO_COMPRA_PLANEJADA',
                  type: 'item',
                  url: '/cadastros/solicitacao-compra',
                  perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
                  breadcrumbs: false
                },
                {
                  id: 'solicitacao-compra-nao-planejada',
                  title: 'SOLICITACAO_COMPRA_NAO_PLANEJADA',
                  type: 'item',
                  url: '/cadastros/solicitacao-compra-nao-planejada',
                  perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
                  breadcrumbs: false
                },
              ]
            },
            {
              id: 'execucao',
              title: 'EXECUCAO',
              type: 'collapse',
              icon: 'feather icon-clipboard',
              perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
              children: [
                {
                  id: 'ordem-servico',
                  title: 'ORDENS_DE_SERVICO',
                  type: 'item',
                  url: '/ordem-servico/ordem-servico',
                  perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
                },
                {
                  id: 'apontamento-ordem-servico',
                  title: 'ATIVIDADES_MAQUINA',
                  type: 'item',
                  url: '/ordem-servico/agenda-atividade',
                  perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
                }
              ]
            },
            {
              id: 'movimento-estoque',
              title: 'Movimento de Estoque',
              type: 'item',
              icon: 'feather icon-package',
              url: '/movimento-estoque/sync',
              perfis: [enumPerfil.Super, enumPerfil.Admin, enumPerfil.Usuario],
            },
            {
              id: 'relatorios',
              title: 'Relatorios',
              type: 'item',
              url: '/relatorios',
              classes: 'nav-item',
              icon: 'feather icon-bar-chart',
              breadcrumbs: false
            },
            {
              id: 'configuracoes',
              title: 'CONFIGURACOES',
              type: 'collapse',
              icon: 'feather icon-settings',
              perfis: [enumPerfil.Super, enumPerfil.Admin],
              children: [
                {
                  id: 'parametrosEmpresa',
                  title: 'Empresa',
                  type: 'item',
                  url: '/cadastros/parametros/empresa'
                },
                {
                  id: 'usuario',
                  title: 'Usuários',
                  type: 'item',
                  url: '/cadastros/usuario',
                  breadcrumbs: false
                },
              ]
            },
          ]
        }
      ];

    return NavigationItems;
  }
  public getProviderFornecedor() {
    var NavigationItems = [
      {
        id: 'other',
        title: 'Fornecedor',
        type: 'group',
        icon: 'feather icon-align-left',
        children: [
          {
            id: 'painel',
            title: 'Painel',
            type: 'item',
            url: '/fornecedor/painel',
            classes: 'nav-item',
            icon: 'feather icon-sidebar',
            breadcrumbs: false
          },
          {
            id: 'configuracoes_fornecedor',
            title: 'CONFIGURACOES',
            type: 'collapse',
            icon: 'feather icon-settings',
            perfis: [enumPerfil.Fornecedor],
            children: [
              {
                id: 'usuario',
                title: 'Usuários',
                type: 'item',
                url: '/fornecedor/usuarios',
                breadcrumbs: false
              },
            ]
          },
        ]
      }
    ];

    return NavigationItems;
  }
}
